var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#EEF2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 11.3335H10.6663C9.92996 11.3335 9.33301 11.9304 9.33301 12.6668V19.3335C9.33301 20.0699 9.92996 20.6668 10.6663 20.6668H21.333C22.0694 20.6668 22.6663 20.0699 22.6663 19.3335V12.6668C22.6663 11.9304 22.0694 11.3335 21.333 11.3335Z",
    stroke: "#4F39F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 14.6665H22.6663",
    stroke: "#4F39F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceId);
export default __webpack_public_path__ + "static/media/insuranceId.75ece52fa65387e2152a2accfdc7247e.svg";
export { ForwardRef as ReactComponent };